/**
 * AutoplayController — gedeelde state-machine voor alle autoplay-sliders
 * (hero-slider, sub-brand-slider). Uniform beleid voor:
 *   - viewport-visibility (IntersectionObserver, threshold 0)
 *   - prefers-reduced-motion met live change-listener
 *   - expliciete pause/resume (touch, drag)
 * Roept `onEnable()` / `onDisable()` alleen op wanneer de run-state
 * daadwerkelijk wisselt — caller hoeft niet zelf te dedupen.
 */
if (!window.AutoplayController) {
class AutoplayController {
  constructor(host, { onEnable, onDisable, threshold = 0 } = {}) {
    this.host = host;
    this._onEnable = onEnable;
    this._onDisable = onDisable;
    this._running = false;
    this._visible = false;
    this._paused = false;

    this._mm = matchMedia('(prefers-reduced-motion: reduce)');
    this._reduced = this._mm.matches;
    this._mmHandler = (e) => { this._reduced = e.matches; this._update(); };
    this._mm.addEventListener?.('change', this._mmHandler);

    this._io = new IntersectionObserver((entries) => {
      for (const e of entries) this._visible = e.isIntersecting;
      this._update();
    }, { threshold });
    this._io.observe(host);
  }

  pause()  { if (!this._paused) { this._paused = true;  this._update(); } }
  resume() { if ( this._paused) { this._paused = false; this._update(); } }

  get reduced() { return this._reduced; }

  shouldRun() {
    return this._visible && !this._paused && !this._reduced;
  }

  _update() {
    const want = this.shouldRun();
    if (want === this._running) return;
    this._running = want;
    try { want ? this._onEnable?.() : this._onDisable?.(); } catch (_) {}
  }

  destroy() {
    this._io?.disconnect();
    this._mm?.removeEventListener?.('change', this._mmHandler);
    if (this._running) { try { this._onDisable?.(); } catch (_) {} }
    this._running = false;
  }
}

window.AutoplayController = AutoplayController;
}
